import { render, staticRenderFns } from "./loading_screen.vue?vue&type=template&id=3fc17406&scoped=true&lang=html&"
import script from "./loading_screen.vue?vue&type=script&lang=js&"
export * from "./loading_screen.vue?vue&type=script&lang=js&"
import style0 from "./loading_screen.vue?vue&type=style&index=0&id=3fc17406&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc17406",
  null
  
)

export default component.exports